import React, { useEffect, useState } from "react";
import customHttp from "../../services/customHTTP";
import { Box, IconButton, Tooltip, CircularProgress } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { AddCircle, ChevronLeft, ChevronRight, Delete } from "@mui/icons-material";
import Datagrid from "../Datagrid/Datagrid";
const ManageMachinesMaster = () => {
	const [allMachines, setAllMachines] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState("");

	useEffect(() => {
		const fetchAllMachines = async () => {
			try {
				const response = await customHttp.get("/machines");
				console.log(response.data.data);
				setAllMachines(response.data.data);
			} catch (error) {
				setError(error.message);
			} finally {
				setLoading(false);
			}
		};
		fetchAllMachines();
	}, []);

	const handleEdit = (machine) => {
		console.log(machine);
	};

	const columns = [
		{ field: "machine_number", headerName: "Machine Number", width: 200 },
		{ field: "machine_name", headerName: "Machine Name", flex: 1 },
		{
			headerName: "Actions",
			sortable: false,
			width: 100, // Ensure there's enough space for icons
			headerAlign: "center",
			align: "left",
			renderCell: (params) => (
				<div>
					<Tooltip title="Edit User">
						<IconButton
							color="primary"
							aria-label="Edit User"
							onClick={(event) => {
								event.stopPropagation();
								handleEdit(params.row);
							}}>
							<EditIcon />
						</IconButton>
					</Tooltip>
				</div>
			),
		},
	];

	const customButtons = [
		{
			label: "Upload New Machines",
			icon: <AddCircle />,
			onClick: () => {
				console.log("Upload New Machines");
			},
		},
		{
			label: "Delete Selected",
			icon: <Delete />,
			onClick: () => {},
		},
	];

	if (loading) {
		return (
			<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "40vh" }}>
				<CircularProgress />
			</Box>
		);
	}

	return (
		<div>
			<Datagrid
				loading={loading}
				data={allMachines}
				columns={columns}
				customButtons={customButtons}
				checkboxSelection={true}
				rowIdField="machine_id"
				sortBy={[{ field: "machine_id", sort: "asc" }]}
			/>
		</div>
	);
};

export default ManageMachinesMaster;
